/** Origines autorisées à envoyer des messages de redimensionnement Datawrapper. */
function isDatawrapperOrigin(origin: string): boolean {
  try {
    const { protocol, hostname } = new URL(origin);
    if (protocol !== "https:") return false;
    return (
      hostname === "datawrapper.dwcdn.net" ||
      hostname.endsWith(".dwcdn.net") ||
      hostname === "datawrapper.de" ||
      hostname.endsWith(".datawrapper.de")
    );
  } catch {
    return false;
  }
}

/** Écoute les messages de hauteur Datawrapper et ajuste l'iframe émettrice. Renvoie la fonction de nettoyage. */
export function listenDatawrapperResize(): () => void {
  const handler = (e: MessageEvent) => {
    if (!isDatawrapperOrigin(e.origin)) return;
    const data = e.data as { [key: string]: unknown } | null;
    if (!data || typeof data !== "object" || !("datawrapper-height" in data)) return;
    const heights = data["datawrapper-height"];
    if (!heights || typeof heights !== "object") return;
    document.querySelectorAll("iframe").forEach((frame) => {
      if (frame.contentWindow !== e.source) return;
      for (const value of Object.values(heights as Record<string, unknown>)) {
        if (typeof value === "number" && Number.isFinite(value) && value > 0 && value < 10000) {
          frame.style.height = `${Math.round(value)}px`;
        }
      }
    });
  };
  window.addEventListener("message", handler);
  return () => window.removeEventListener("message", handler);
}
